import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

function buildQueryString(filters) {
  const params = new URLSearchParams();

  Object.keys(filters).forEach(key => {
    const value = filters[key];
    if (value !== null && value !== undefined && value !== '') {
      if (typeof value === 'boolean') {
        params.append(key, value ? '1' : '0');
      } else {
        params.append(key, value);
      }
    }
  });

  return params.toString();
}

export async function getEgresos(filters = {}, apiBasePath = '/api/admin') {
  const query = buildQueryString(filters);
  const url = query
    ? `${API_BASE_URL}${apiBasePath}/egresos?${query}`
    : `${API_BASE_URL}${apiBasePath}/egresos`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden acceder a esta informacion.');
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al consultar egresos'}`);
  }

  return res.json();
}

export async function createEgreso(payload, apiBasePath = '/api/admin') {
  const url = `${API_BASE_URL}${apiBasePath}/egresos`;

  const res = await fetchWithAuth(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden acceder a esta informacion.');
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al registrar egresos'}`);
  }

  return res.json();
}

export async function updateEgreso(id, payload, apiBasePath = '/api/admin') {
  const url = `${API_BASE_URL}${apiBasePath}/egresos/${id}`;

  const res = await fetchWithAuth(url, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden acceder a esta informacion.');
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al actualizar egresos'}`);
  }

  return res.json();
}

export async function deleteEgreso(id, apiBasePath = '/api/admin') {
  const url = `${API_BASE_URL}${apiBasePath}/egresos/${id}`;

  const res = await fetchWithAuth(url, {
    method: 'DELETE',
    headers: { 'Accept': 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden acceder a esta informacion.');
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al eliminar egreso'}`);
  }

  return res.json();
}
